import { useState, useEffect } from 'react';
import { getWorkAssignmentByCurrentRecruiterAndJob, IWorkAssignment } from 'wisestep-api';

const useWorkAssignmentFromJobId = (jobId: string) => {
  const [workAssignmentFromJobId, setWorkAssignmentFromJobId] = useState<IWorkAssignment>();

  useEffect(() => {
    const getAssignedTeams = async () => {
      if (jobId) {
        const assignedTeamsByJobId = await getWorkAssignmentByCurrentRecruiterAndJob(jobId);
        setWorkAssignmentFromJobId(assignedTeamsByJobId.data);
      }
    };
    getAssignedTeams();
  }, [jobId]);

  return workAssignmentFromJobId;
};

export default useWorkAssignmentFromJobId;
